import React from 'react';
import CareerForm from '../components/CareerForm';

const Careers = () => {
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      <CareerForm />
    </div>
  );
};

export default Careers;
